import OnHoverOption from "@/components/PaidUsers/OnHoverOption";
import Actions from "@/elements/Actions";
import { Mixpanel } from "@/elements/Mixpanel";
import NseOrBsePrice from "@/elements/NseOrBsePrice/NseOrBsePrice";
import { getLivePrice } from "@/lib/tradeCards";
import { cn, putComma } from "@/lib/utils";
import moment from "moment";
import { useRouter } from "next/router";
import React, { useCallback } from "react";
import { MdChevronRight } from "react-icons/md";

const FuturesSections = ({ futures, finCode, parentFinCode, activeChartType }) => {
    const router = useRouter();

    return (
        <div className="w-full flex flex-col items-start gap-3  py-0">
            <h2 className="text-[#232A31] text-sm font-semibold leading-6 font-Inter md:text-base md:leading-8 px-4">
                Futures
            </h2>
            <div className="px-4 w-full">
                <div className=" w-full grid grid-cols-3 md:grid-cols-4 text-[#202020] text-xs font-semibold mb-2 bg-[#F5f5f5] p-2 rounded-md">
                    <p className="col-span-1 text-[10px] font-semibold md:text-sm md:leading-6">Expiry</p>
                    <p className="col-span-1 min-w-[150px] text-[10px] font-semibold md:text-sm md:leading-6 md:pl-[68px]">
                        Price
                    </p>
                    <p className="col-span-1 min-w-[150px] text-[10px] font-semibold md:text-sm md:leading-6 hidden md:block md:pl-9">
                        Volume
                    </p>
                    <p className="col-span-1 text-[10px] font-semibold md:text-sm md:leading-6 md:pl-3">
                        Change (%age)
                    </p>
                </div>
            </div>
            <div className="flex w-full flex-col gap-2.5 pb-16 px-4">
                {futures
                    ?.filter((ele) => (finCode ? ele.finCode !== finCode : true))
                    .map((ele, index, arr) => {
                        return (
                            <div
                                key={ele.finCode}
                                className={cn(
                                    `w-full grid grid-cols-3 md:grid-cols-4 items-center py-2 border-solid cursor-pointer`,
                                    { "border-b border-b-[#DFDFDF]": index === arr.length - 1 }
                                )}
                                onClick={() => {
                                    Mixpanel.track("cta_clicked", {
                                        page: "index_sdp",
                                        widget: "index_future",
                                        fincode: ele?.finCode,
                                        symbol: ele?.symbol
                                    });
                                    router.push(Actions.toFNODetail(`${finCode}-${ele?.finCode}`));
                                    // console.log(ele);
                                }}
                            >
                                <div className="col-span-1 text-[#202020] text-xs font-semibold leading-5 md:hidden block">
                                    <p className="whitespace-nowrap">{ele?.title}</p>
                                    <p className="self-stretch text-[#9D9D9D] text-[10px] font-medium leading-4">
                                        {ele?.subtitle}
                                    </p>
                                </div>

                                <div className="col-span-1 text-[#202020] text-xs font-semibold leading-5 hidden md:flex flex-col gap-1 uppercase relative cursor-pointer group">
                                    <p>{ele?.title}</p>
                                    <p className="text-[#9d9d9d] leading-5">{ele?.subtitle}</p>

                                    <OnHoverOption
                                        bseSymbol={ele?.symbol}
                                        nseSymbol={ele?.symbol}
                                        finCode={ele?.finCode}
                                        exchange={activeChartType === 1 ? "NSE" : "BSE"}
                                        source="market_home"
                                        className={"group-hover:-right-4"}
                                        onClickTradingView={() => {
                                            getLivePrice([ele?.finCode]).then((res) => {
                                                if (res[ele?.finCode]) {
                                                    Mixpanel.track("cta_clicked", {
                                                        page: "Index_sdp",
                                                        widget: "index_option",
                                                        fincode: ele?.finCode,
                                                        symbol: ele?.symbol
                                                    }),
                                                        router.push(
                                                            Actions.toFNODetail(
                                                                `${parentFinCode}-${ele?.finCode}/charts`
                                                            )
                                                        );
                                                }
                                            });
                                        }}
                                    />
                                </div>

                                <div className="col-span-1 text-[#202020] text-xs font-semibold leading-5 md:pl-20">
                                    ₹{putComma(ele.ltpPrice)}
                                    <p className="self-stretch text-[#606060] text-[10px] font-medium leading-4 md:hidden">
                                        Vol: {putComma(ele.volume, 0)}
                                    </p>
                                </div>

                                <div className="col-span-1 text-[#202020] text-xs font-semibold leading-6 hidden md:block md:pl-14">
                                    {putComma(ele.volume, 0)}
                                </div>

                                <div className="col-span-1 flex flex-row justify-between items-center gap-2  md:pl-8">
                                    <NseOrBsePrice
                                        textClass="text-xs font-semibold leading-5"
                                        nseClosePrice={ele.closePrice}
                                        nseLtpPrice={ele.ltpPrice}
                                    />
                                    <MdChevronRight className="text-[#606060] text-xl" />
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default FuturesSections;
